import { v4 } from 'uuid';
import { RETURN_LOCATION_MODE } from '../../actions';

const COORD_EPSILON = 0.000001;

export const coordMatchByCoords = (lat, lng) => (loc) =>
  loc?.lat !== undefined &&
  Math.abs(loc.lat - lat) < COORD_EPSILON &&
  Math.abs(loc.lng - lng) < COORD_EPSILON;

export const coordMatchByOldLocation = (oldLat, oldLng) => (r) =>
  r?.location?.lat !== undefined &&
  Math.abs(r.location.lat - oldLat) < COORD_EPSILON &&
  Math.abs(r.location.lng - oldLng) < COORD_EPSILON;

export const updateReloadLocation = (reloads, oldCoords, newLat, newLng, newAddress) => {
  const [oldLng, oldLat] = oldCoords;
  const isMatch = coordMatchByOldLocation(oldLat, oldLng);
  return reloads.map((r) =>
    isMatch(r) ? { ...r, location: { lat: newLat, lng: newLng }, address: newAddress } : r,
  );
};

export const updatePudoLocation = (groups, pudoId, newLat, newLng) => {
  return groups.map((group) => ({
    ...group,
    pudos: group.pudos.map((pudo) => {
      if (pudo.id === pudoId) {
        return {
          ...pudo,
          places: pudo.places.map((place) => ({
            ...place,
            location: {
              ...place.location,
              lat: newLat,
              lng: newLng,
            },
          })),
        };
      }
      return pudo;
    }),
  }));
};

export const updateDepotLocation = (location, returnLocationMode) => {
  const params = { location };
  if (returnLocationMode === RETURN_LOCATION_MODE.START) {
    params.returnLocation = location;
  }
  return params;
};

export const updateOrderLocation = (order, location, feature, isEditing) => {
  return {
    ...order,
    InternalID: !isEditing ? order.InternalID : v4(),
    Address: location.label,
    Latitude: location.value.lat,
    Longitude: location.value.lng,
    Activity: feature.properties.types[0],
    Dragged: true,
    TimeCreated: Date.now(),
  };
};

export const findOrderIndex = (orders, featureID, isPickup) => {
  return orders.findIndex(
    (order) =>
      order.InternalID === featureID && order.Activity === (isPickup ? 'pickup' : 'delivery'),
  );
};

export const handleMarkerDragEnd = ({
  marker,
  feature,
  location,
  tourPlanner,
  orders,
  solution,
  display,
  isPointDepot,
  isPointReturnLocation,
}) => {
  const actions = [];
  const isEditing = feature.properties.isEditing;
  const featureID = feature.properties.id;
  const isPickup = feature.properties.isPickup;

  actions.push({
    type: 'SELECT_TOUR',
    payload: { selectedTour: display.selectedTour, noMapMovement: true },
  });

  const latlng = marker.getLatLng();
  feature.geometry.coordinates = [latlng.lng, latlng.lat];

  if (isPointDepot(feature)) {
    const depotParams = updateDepotLocation(location, tourPlanner.returnLocationMode);
    actions.push({
      type: 'SET_TOUR_PARAMETER',
      payload: depotParams,
    });

    if (solution.json) {
      actions.push(
        { type: 'SET_SOLUTION_JSON', payload: { jsonUserChange: 'ordersDepot' } },
        { type: 'SET_SOLUTION_JSON', payload: { jsonTriggerVRP: true } },
      );
    }
    return actions;
  }

  if (isPointReturnLocation(feature)) {
    actions.push({
      type: 'SET_TOUR_PARAMETER',
      payload: { returnLocation: location },
    });

    if (solution.json) {
      actions.push(
        { type: 'SET_SOLUTION_JSON', payload: { jsonUserChange: 'ordersEndLoc' } },
        { type: 'SET_SOLUTION_JSON', payload: { jsonTriggerVRP: true } },
      );
    }
    return actions;
  }

  if (feature.properties.isPudo) {
    const updatedGroups = updatePudoLocation(
      tourPlanner.groups,
      featureID,
      location.value.lat,
      location.value.lng,
    );

    actions.push(
      { type: 'SET_TOUR_PARAMETER', payload: { groups: updatedGroups } },
      { type: 'SET_SOLUTION_JSON', payload: { jsonTriggerVRP: true } },
    );
    return actions;
  }

  const orderIndex = findOrderIndex(orders, featureID, isPickup);

  if (orderIndex >= 0) {
    const baseOrder = isEditing ? tourPlanner.editedOrder : orders[orderIndex];
    const updatedOrder = updateOrderLocation(baseOrder, location, feature, isEditing);

    const updatedOrders = [...orders];
    updatedOrders[orderIndex] = updatedOrder;

    if (!isEditing) {
      actions.push(
        { type: 'SET_ORDERS', payload: updatedOrders },
        { type: 'SET_SOLUTION_JSON', payload: { jsonTriggerVRP: true } },
      );
    } else {
      actions.push({
        type: 'SET_TOUR_PARAMETER',
        payload: {
          editedOrder: {
            ...tourPlanner.editedOrder,
            Address: location.label,
            Latitude: location.value.lat,
            Longitude: location.value.lng,
          },
        },
      });
    }
  }

  return actions;
};
